export const onServiceWorkerUpdateReady = () => {
  const answer = true

  if (answer === true) {
    window.location.reload(true)
  }
}
